import { CommunicationWorkflowTargetOrderByName } from '@pwp-common';

import { TargetOrderByEditorOutput } from './target-order-by-editor-output';

export const defaultTargetOrderBy: TargetOrderByEditorOutput = {
  type: CommunicationWorkflowTargetOrderByName.explicit,
};
